export function ConnectedWorkflowArt() {
  return (
    <figure className="mh-flow-art">
      <img
        src="/illustration-connected-workflow.png"
        alt="Concept illustration of the Paddiq Link beta workflow, connecting a MyChron logger to a shared Paddiq workspace"
        width="1536"
        height="1024"
        loading="lazy"
      />
      <figcaption>
        <span>
          <small>01 / CAPTURE</small>MyChron
        </span>
        <span>
          <small>02 / BETA</small>Paddiq Link
        </span>
        <span>
          <small>03 / ANALYZE</small>Paddiq
        </span>
      </figcaption>
    </figure>
  );
}
